import { Link, PricingOptionsProps } from "@areahub/ui";
import {
  Box,
  BoxProps,
  Button,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  Heading,
  Icon,
  Image,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { RichText } from "@graphcms/rich-text-react-renderer";
import { FaCheckCircle } from "react-icons/fa";
import { blockRenderers } from "../../../../../apps/www/components/individuals/mdx-components";

export interface PriceCardProps extends BoxProps {
  title: string;
  pricingOptions: PricingOptionsProps[];
  featureList: any[];
  button: string;
  mobileSubtitle: string;
  desktopSubtitle: string;
  planImage: any;
  plan: string;
}

export const MobilePriceCard = ({
  title,
  pricingOptions,
  featureList,
  button,
  children,
  planImage,
  mobileSubtitle,
  desktopSubtitle,
  plan,
  ...props
}: PriceCardProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const planItem = pricingOptions.find((item) => item.title === plan);
  const price = planItem?.price;

  return (
    <>
      {/* Mobile Display */}
      <Box
        p={{
          base: 0,
          md: 3,
          lg: 5,
        }}
        borderRadius={{
          base: "xl",
          md: "none",
        }}
        position="relative"
        w="100%"
        h={{
          md: "680px",
        }}
        display={{
          base: "block",
          md: "none",
        }}
      >
        <Box
          maxW={{ lg: "350px" }}
          minW={{
            base: "90vw",
            md: "250px",
          }}
          h="100%"
          bgColor="white"
          border="1px solid black"
          borderRadius="lg"
          boxShadow={{
            base: "1px 2px 5px 1px rgba(136, 136, 136, 0.8)",
            md: "none",
          }}
          {...props}
        >
          <Flex
            flexDir={{
              base: "row",
              md: "column",
            }}
            gap={6}
            px={{
              base: 5,
              md: 0,
            }}
            py={2}
          >
            <>
              <Image src={planImage.url} w="50px" h="fit-content" my="auto" />
              <Flex flexDir="column" alignItems="flex-start" w="100%">
                <Heading
                  fontSize={{
                    base: 16,
                    md: 20,
                  }}
                  fontWeight={{
                    base: "normal",
                    md: "extrabold",
                  }}
                  h="30px"
                >
                  {title}
                </Heading>
                <Text
                  fontWeight="bold"
                  filter={`${plan === "Pro" ? "blur(7px)" : ""}`}
                >
                  {plan === "Pro" ? "$" : ""}
                  {price}
                </Text>
                <Text
                  alignSelf="flex-end"
                  fontSize={13}
                  fontStyle="italic"
                  textDecor="underline"
                  cursor="pointer"
                  onClick={onOpen}
                >
                  Learn more
                </Text>
              </Flex>
              <Drawer placement="bottom" onClose={onClose} isOpen={isOpen}>
                <DrawerOverlay />
                <DrawerContent>
                  <DrawerCloseButton />
                  <DrawerHeader
                    fontSize={16}
                    fontWeight="normal"
                    textTransform="uppercase"
                  >
                    {title}
                  </DrawerHeader>
                  <DrawerBody>
                    <Box
                      border="1px solid #D9D9D9"
                      py={6}
                      mb={20}
                      px={9}
                      borderRadius="md"
                      boxShadow="lg"
                      h="450px"
                      bgColor="white"
                      overflowY="auto"
                    >
                      <Text
                        textTransform="uppercase"
                        color="#9A9A9A"
                        pb={2}
                        fontSize={14}
                      >
                        Learn more
                      </Text>
                      <Text
                        pb={5}
                        fontSize={19}
                        filter={`${plan === "Pro" ? "blur(7px)" : ""}`}
                      >
                        {plan === "Pro" ? "$" : ""}
                        {price}
                      </Text>
                      <Text
                        fontSize={14}
                        color="#3B82F6"
                        fontWeight="bold"
                        pb={9}
                      >
                        {mobileSubtitle}
                      </Text>

                      {featureList.map((feature, idx) => (
                        <Flex
                          key={`feature-list-item-${idx}`}
                          alignItems="flex-start"
                          gap={4}
                          fontSize={{
                            base: 13,
                            sm: 14,
                          }}
                          pb={3}
                          filter={`${plan === "Pro" ? "blur(7px)" : ""}`}
                        >
                          <Icon as={FaCheckCircle} color="gray.600" my="4px" />
                          <RichText
                            content={feature?.feature?.raw}
                            renderers={blockRenderers}
                          />
                        </Flex>
                      ))}
                    </Box>
                    {plan === "Pro" ? (
                      <Button
                        disabled
                        cursor={"unset"}
                        bgColor="#3B82F6"
                        fontWeight="bold"
                        color="white"
                        mb={3}
                        position="absolute"
                        bottom={0}
                        left="50%"
                        transform="translate(-50%, -50%)"
                        w="75%"
                        textTransform="uppercase"
                        _hover={{
                          bgColor: "#3B82F6",
                        }}
                      >
                        {button}
                      </Button>
                    ) : (
                      <Link href="/enterprise-contact">
                        <Button
                          bgColor="#3B82F6"
                          fontWeight="bold"
                          color="white"
                          mb={3}
                          position="absolute"
                          bottom={0}
                          left="50%"
                          transform="translate(-50%, -50%)"
                          w="75%"
                          textTransform="uppercase"
                        >
                          {button}
                        </Button>
                      </Link>
                    )}
                  </DrawerBody>
                </DrawerContent>
              </Drawer>
            </>
          </Flex>
        </Box>
      </Box>
    </>
  );
};
